import React from 'react';
import { notification } from 'antd';
import styled from 'styled-components';
import { CheckCircleFilled, ExclamationCircleFilled, InfoCircleFilled, StopFilled } from '@ant-design/icons';
import { ArgsProps } from 'antd/lib/notification';

interface IconWrapperProps {
  $isOnlyTitle: boolean;
}

const IconWrapper = styled.div<IconWrapperProps>`
  font-size: ${(props) => (props.$isOnlyTitle ? '16px' : '18px')};
  line-height: 1;
`;

const MessageText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
`;

const DescriptionText = styled.div`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.3;
  margin-top: 3px;
`;

const EmptyDescription = styled.div`
  margin-top: -0.5rem;
`;

// Compact notification style class
const compactStyle = 'compact-notification';

type NotificationProps = ArgsProps;

const openSuccessNotification = (config: NotificationProps): void => {
  notification.success({
    ...config,
    icon: (
      <IconWrapper $isOnlyTitle={!config.description}>
        <CheckCircleFilled className="success-icon" />
      </IconWrapper>
    ),
    message: <MessageText>{config.message}</MessageText>,
    description: config.description ? <DescriptionText>{config.description}</DescriptionText> : <EmptyDescription />,
    className: `${compactStyle} ${config.description ? '' : 'notification-without-description'}`,
    duration: 3,
  });
};

const openInfoNotification = (config: NotificationProps): void => {
  notification.info({
    ...config,
    icon: (
      <IconWrapper $isOnlyTitle={!config.description}>
        <InfoCircleFilled className="info-icon" />
      </IconWrapper>
    ),
    message: <MessageText>{config.message}</MessageText>,
    description: config.description ? <DescriptionText>{config.description}</DescriptionText> : <EmptyDescription />,
    className: `${compactStyle} ${config.description ? '' : 'notification-without-description'}`,
    placement: 'bottom',
    duration: 5,
  });
};

const openWarningNotification = (config: NotificationProps): void => {
  notification.warning({
    ...config,
    icon: (
      <IconWrapper $isOnlyTitle={!config.description}>
        <ExclamationCircleFilled className="warning-icon" />
      </IconWrapper>
    ),
    message: <MessageText>{config.message}</MessageText>,
    description: config.description ? <DescriptionText>{config.description}</DescriptionText> : <EmptyDescription />,
    className: `${compactStyle} ${config.description ? '' : 'notification-without-description'}`,
    duration: 4,
  });
};

const openErrorNotification = (config: NotificationProps): void => {
  notification.error({
    ...config,
    icon: (
      <IconWrapper $isOnlyTitle={!config.description}>
        <StopFilled className="error-icon" />
      </IconWrapper>
    ),
    message: <MessageText>{config.message}</MessageText>,
    description: config.description ? <DescriptionText>{config.description}</DescriptionText> : <EmptyDescription />,
    className: `${compactStyle} ${config.description ? '' : 'notification-without-description'}`,
    duration: 5,
  });
};

export const notificationController = {
  success: openSuccessNotification,
  info: openInfoNotification,
  warning: openWarningNotification,
  error: openErrorNotification,
};
